import React from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

import styled from '@mui/material/styles/styled';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Icon from '@mui/material/Icon';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Root = styled('div')({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
});

function FallBackComponent() {
  return (
    <Root>
      <Grid container justifyContent='center' alignItems='center'>
        <Grid item xs={12} justifyContent='center' alignItems='center'>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              width: '100%',
              height: '100%',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Stack
              spacing={2}
              sx={(theme) => ({
                backgroundColor: theme.palette.background.default,
                borderRadius: theme.spacing(1),
                justifyContent: 'center',
                alignItems: 'center',
                width: '50%',
                height: '50%',
                p: 3,
              })}>
              <Icon
                fontSize='large'
                sx={(theme) => ({
                  color: theme.veregy.colors.red,
                  width: '100%',
                  height: '100%',
                })}>
                <FontAwesomeIcon icon={['fal', 'do-not-enter']} size='lg' />
              </Icon>

              <h1>Whoops! Something went wrong...</h1>
              <Link underline='hover' href='/app/portfolio'>
                Application Home
              </Link>
              <Link underline='hover' href='/auth'>
                Login Page
              </Link>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Root>
  );
}

const fallback = <FallBackComponent />;

class ErrorBoundary extends React.Component {
  render() {
    return (
      <SentryErrorBoundary fallback={fallback}>
        {this.props.children}
      </SentryErrorBoundary>
    );
  }
}

export default ErrorBoundary;
